import { useState } from 'react';

interface SignalStrengthBadgeProps {
  rssi?: number | null;
  online: boolean;
}

const rssiToBars = (rssi?: number | null): 0 | 1 | 2 | 3 | 4 => {
  if (rssi == null) return 0;
  if (rssi >= -65) return 4;
  if (rssi >= -75) return 3;
  if (rssi >= -85) return 2;
  if (rssi >= -95) return 1;
  return 0;
};

const barColorClass = (bars: 0 | 1 | 2 | 3 | 4): string => {
  if (bars >= 3) return 'bg-success-500';
  if (bars === 2) return 'bg-primary-500';
  return 'bg-error-500';
};

const SignalStrengthBadge: React.FC<SignalStrengthBadgeProps> = ({ rssi, online }) => {
  const [hovered, setHovered] = useState(false);
  const bars = online ? rssiToBars(rssi) : 0;
  const tooltipValue = !online || rssi == null ? '--' : `${rssi} dBm`;

  return (
    <div className="flex flex-col items-center gap-1 w-16">
      <span className="text-neutral-60 typo-small">Signal</span>
      <div
        className="relative flex items-end h-5 gap-0.5"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {[1, 2, 3, 4].map((bar) => (
          <div
            key={bar}
            className={`w-1 rounded-sm ${bar <= bars ? barColorClass(bars) : 'bg-neutral-10'}`}
            style={{ height: `${bar * 4 + 4}px` }}
          />
        ))}
        {hovered && (
          <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 px-2 py-1 bg-neutral rounded-md whitespace-nowrap pointer-events-none z-10">
            <span className="text-white typo-caption">{tooltipValue}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignalStrengthBadge;
